export default __webpack_public_path__ + "static/featurePhone1-5c46373d19c72ed7c416ca7c5fa3a182.png";